import { BILLING_CYCLE, planTypes, billingCycleDependBasePlanTypeList, licenseDependBasePlanTypeList } from '@/common/constants';
import { getCartInfo } from '@/common/service/default-mapper';
import { planUnitMap } from '@/common/product-unit'

const usersLimit = { max: 9999, min: 1 };

function pickInfo(planNode) {
  const result = [];
  const onlinePlanMap = {
    [BILLING_CYCLE.ANNUAL]: 'cmp_annual',
    [BILLING_CYCLE.MONTHLY]: 'cmp_monthly',
  };
  Object.keys(onlinePlanMap).forEach((currentBillingCycle) => {
    const onlinePlan = planNode[onlinePlanMap[currentBillingCycle]];
    if (onlinePlan) {
      const { prices, plan_code, plan_type } = onlinePlan;
      const formattedPlan = {
        type: planTypes.CONCURRENT_MEETING_PLUS,
        category: 'CCM',
        sub_type: 'CCM',
        plan_code: plan_code,
        plan_type,
        amount: prices[0].price,
        prices,
        cartInfo: getCartInfo(),
        billing_cycle: currentBillingCycle,
        typeNameKey: 'billing.concurrent_meeting_plus.title',
        planNameKey: 'billing.concurrent_meeting_plus.title',
        supportCoupon: true,
        dependBasePlanTypeList: [],
        billingCycleDependBasePlanTypeList,
        // BUY TRIAL
        // FREE TRIAL
        isOnlineFreeTrial: false,
        trialDays: undefined,
        trialCode: '',
        ...usersLimit,
        licenseDependBasePlanTypeList,
        unit: planUnitMap.license
      };

      result.push(formattedPlan);
    }
  });
  return result;
}
export default (planMapJSON) => pickInfo(planMapJSON.cmp_price_list || {});
